import React from 'react'
import PropTypes from 'prop-types'
import BEM from '@iui-kit/utils/bem'
import styles from './Radio.css'

const bem = new BEM(styles)

const Radio = ({ onChange, disabled, checked, children, className, isValid, ...other }) => (
  <label
    className={bem
      .b('radio')
      .m('disabled', disabled)
      .m('invalid', !isValid)
      .mix(className)
      .show()}
  >
    <input
      {...other}
      type="radio"
      className={bem
        .b('radio')
        .e('input')
        .show()}
      onChange={onChange}
      checked={checked}
      disabled={disabled}
    />
    <span
      className={bem
        .b('radio')
        .e('indicator')
        .show()}
    />
    {children}
  </label>
)

Radio.propTypes = {
  children: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  className: PropTypes.string,
  disabled: PropTypes.bool,
  checked: PropTypes.bool,
  isValid: PropTypes.bool,
  onChange: PropTypes.func.isRequired
}

Radio.defaultProps = {
  children: null,
  className: null,
  disabled: false
}

export default Radio
